// Customer service related translations
export default {
  title: "Contact Customer Service",
  description:
    "If you need to contact customer service, please scan the QR code below to add customer service.",
  wechatPublic: "WeChat Official Account",
  wechatCustomer: "WeChat Customer Service",
  loading: "Loading...",
  contactButton: "Contact Customer Service",
};
